import type { ReactElement } from 'react';
import { useMemo } from 'react';

import type { CircularProgressProps } from '@mui/material/CircularProgress';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { alpha, useTheme } from '@mui/material/styles';

export const LoadingSpinner = (props: CircularProgressProps): ReactElement => {
    const { palette } = useTheme();

    const color = useMemo(
        () => props.color ?? palette.primary.main,
        [palette.primary.main, props.color]
    );

    return (
        <Box sx={{ position: 'relative' }}>
            <CircularProgress
                variant="determinate"
                size={40}
                thickness={4}
                sx={{
                    color: alpha(color, 0.2),
                }}
                {...props}
                value={100}
            />
            <CircularProgress
                variant="indeterminate"
                size={40}
                value={25}
                thickness={4}
                sx={{
                    color,
                    animationDuration: '500ms',
                    position: 'absolute',
                    left: 0,
                    ['& .MuiCircularProgress-circle']: {
                        strokeDasharray: '30px, 100px',
                    },
                }}
                disableShrink
                {...props}
            />
        </Box>
    );
};

export type { CircularProgressProps as LoadingSpinnerProps };
